import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { CnIcon } from '@sto/cn-ui';
import styles from './index.module.scss';

/**
 * 自定义单选组组件
 * @returns 
 */
const CustomRadioGroup = ({ dataSource, value, onChange, innerBefore = null, innerAfter = null }) => {
  const [checked, setChecked] = useState(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleChange = (item) => {
    onChange?.(item?.value || item);
  };

  const formatDataSource = useMemo(() => {
    return dataSource?.map((item) => {
      if (typeof item === 'object') {
        return item;
      }
      return {
        label: item,
        value: item,
      };
    });
  }, [dataSource]);

  /**
   * 渲染内联元素
   * @param config 内联元素配置
   * @returns 内联元素
   */
  const renderInnerDom = useCallback((config) => {
    const { type, content, size = 'medium', style = {} } = config || {};
    switch (type) {
      case 'img':
        return <img src={content} alt="" style={{ width: '14px',  ...style }} />;  
      case 'icon':
        return <CnIcon type={content} size={size} style={style} />;
      case 'text':
        return <span style={style}>{content}</span>;
      default:
        return <span style={style}>{config}</span>;
    }
  }, []);

  return (
    <div className={styles.customRadioGroup}>
      {formatDataSource?.map((item, index) => (
        <div 
          key={item?.value || index} 
          className={`${styles.customRadioGroupItem} ${checked === item?.value ? styles.active : ''}`} 
          onClick={() => {
            handleChange(item);
          }}
        >
          {innerBefore && renderInnerDom(innerBefore)}
          {item?.label || item}
          {innerAfter && renderInnerDom(innerAfter)}
        </div>
      ))}
    </div>
  );
};

export default CustomRadioGroup;